import type { FC, ReactNode } from "react";
import { CardThumbnail, type CardThumbnailBadge } from "../Card";
import computeBadge, { BADGE_TRANSLATION_KEYS } from "./computeBadge";

export { BADGE_TRANSLATION_KEYS };

import computeProvider from "./computeProvider";

// Declared, not imported: this package has no codegen, and all-optional fields keep it assignable.
export type GameThumbData = {
  name?: string | null;
  isNew?: boolean | null;
  isHot?: boolean | null;
  isTrending?: boolean | null;
  isHighRoller?: boolean | null;
  thumbUrl?: string | null;
  thumbUrlTab?: string | null;
  // List items may be `null` (sports codegen) or `undefined` (casino_core).
  menuItem?: Array<
    | {
        name?: string | null;
        handle?: string | null;
      }
    | null
    | undefined
  > | null;
  themes?: {
    edges?: Array<
      | {
          node?: { id?: string | null; name?: string | null } | null;
        }
      | null
      | undefined
    > | null;
  } | null;
};

type Props = {
  game: GameThumbData;
  link: ReactNode;
  providerLink?: ReactNode;
  hover?: ReactNode;
  badge?: CardThumbnailBadge;
  translations?: Record<string, string>;
  size?: "auto" | "normal";
};

const GameThumb: FC<Props> = ({
  game,
  link,
  providerLink,
  hover,
  badge,
  translations,
  size = "normal",
}) => {
  const computedProvider = computeProvider(game);
  const provider = computedProvider
    ? { name: computedProvider.name, link: providerLink }
    : undefined;

  return (
    <CardThumbnail
      link={link}
      hover={hover}
      title={game.name ?? ""}
      badge={badge ?? computeBadge(game, translations) ?? undefined}
      provider={provider}
      size={size}
    />
  );
};

export default GameThumb;
